/**
 * @Desription: 语言包
 * @Author: netstar.sjj
 * @Date: 2021-10-18 11:05:00
 * @class NSLanguage
*/
import enLanguage from './en-language';
import zhLanguage from './zh-language';
declare const navigator:any;
declare const languagePackage:any;
declare const window:any;
namespace NSLanguage{
    export const languagePackage:any = {
        zh:zhLanguage,
        en:enLanguage
    }
    export function getUserLanguage(){
        /**
         * @msg: 返回浏览器用户语言
         * @param：-
         * @return: string 例如 zh（简体中文）en（英文）
         */
        let userLanguage:string = "zh"; //默认简体中文
        let languageStr:string = window.store.get('language');
        if(languageStr){
            userLanguage = languageStr;
        }
        if(navigator.userLanguage){
            userLanguage = navigator.userLanguage.substring(0, 2).toLowerCase();
        } else {
            userLanguage = navigator.language.substring(0, 2).toLowerCase();
        }
        return userLanguage;
    }
    languagePackage.userLang = getUserLanguage();//当前语言
    export const language = languagePackage[languagePackage.userLang];//当前语言包
    export function getI18n(I18N:any){
        /**
         * @msg: 方法说明
         * @param I18N:object {zh:{name:"简体中文", ...},en:{}}
         * @return: i18n:object {name:"简体中文", ...}
         */
        let i18n:any = I18N[languagePackage.userLang];
        if (window.debugerMode) {
            if (typeof (i18n) != "object") {
                console.error("无法找到当前语言包：" + languagePackage.userLang);
                console.error(I18N);
            }
        }
        return i18n;
    }
}
export default NSLanguage;